import {useState, useEffect} from 'react';
import { Grid, Button, Typography } from '@mui/material';
import ManagePackagingMaterial from 'components/phproductform/components/ManagePackagingMaterial';

export default function ManagePackagingMaterialActionImpl(){

    return (
        <>
        <ManagePackagingMaterial/>
        </>
    )
}